import React from 'react';

export default function OfflineBanner() {
  return (
    <div style={{
      background: '#e74c3c',
      color: 'white',
      textAlign: 'center',
      padding: '2px',
      fontSize: '10px',
      fontWeight: 'bold',
      position: 'sticky',
      top: 0,
      zIndex: 9999
    }}>
      ⚠️ You are currently offline. Running in offline mode.
    </div>
  );
}